import { Select } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMemo, useState } from 'react';
import { IoIosArrowDown } from 'react-icons/io';
import { IoIosArrowUp } from 'react-icons/io';

const CustomDropdown = observer(
    ({
        options = [],
        value,
        onChange,
        className,
        placeholder,
        mode,
        allowClear,
        rootClassName,
        variant,
        popupClassName,
        isColor = false,
    }) => {
        const [isOpen, setIsOpen] = useState(false);
        const handleDropdownVisibleChange = (visible) => {
            setIsOpen(visible);
        };
        const normalizedOptions = useMemo(() => {
            if (isColor) {
                return options.map((item) => ({
                    label: (
                        <div className="flex items-center gap-2">
                            <span
                                className="inline-block w-[24px] h-[24px] rounded-full border border-theme-button-bg"
                                style={{
                                    backgroundImage: item.colorCode.includes(
                                        'gradient',
                                    )
                                        ? item.colorCode
                                        : undefined,
                                    backgroundColor: !item.colorCode.includes(
                                        'gradient',
                                    )
                                        ? item.colorCode
                                        : undefined,
                                }}></span>
                            <span>{item.name || item.label || 'Unknown'}</span>
                        </div>
                    ),
                    value: item.id || item.value || item.key || item.label,
                    rawLabel: item.name || item.label || 'Unknown',
                    color: item.colorCode,
                }));
            } else {
                return options.map((item) => ({
                    label: item.label || item.name || item.title || 'Unknown',
                    original: item,
                    value: item.id || item.value || item.key || item.label,
                }));
            }
        }, [options, isColor]);

        return (
            <div className={`${className}`}>
                <Select
                    variant={variant}
                    optionLabelProp="label"
                    mode={mode}
                    allowClear={allowClear}
                    style={{ width: '100%' }}
                    placeholder={placeholder}
                    open={isOpen}
                    onDropdownVisibleChange={handleDropdownVisibleChange}
                    value={value}
                    onChange={onChange}
                    options={normalizedOptions}
                    rootClassName={`${rootClassName} custom-select-root`}
                    popupClassName={`${popupClassName} custom-select-popup`}
                    className="custom-select"
                    //   showSearch={false}
                    suffixIcon={
                        isOpen ? (
                            <IoIosArrowUp className="text-theme-black text-[20px]" />
                        ) : (
                            <IoIosArrowDown className="text-theme-black text-[20px]" />
                        )
                    }
                />
            </div>
        );
    },
);

export default CustomDropdown;
